module.exports = __webpack_public_path__ + "img/qr.3059f812.png";